import { availabilityLabel, featureAvailability } from '../features/subscription/planComparison';

/**
 * The one small label for a feature that is not simply "available": Beta (usable, still being proven), Coming soon, Pilot only
 * or Not available right now. It renders nothing for a plain Operational feature. The text is real text, never color alone, and
 * the glyph is decoration. Use it wherever a feature is listed so the same wording appears everywhere.
 */
export function FeatureAvailabilityBadge({ readinessStatus }: { readinessStatus: string }) {
  const availability = featureAvailability({ readinessStatus });
  const label = availabilityLabel(availability);
  if (!label) return null;
  const modifier = availability === 'beta' ? 'beta' : 'coming-soon';
  return (
    <span className={`entitlement-badge entitlement-badge--${modifier}`} data-availability={availability}>
      {availability === 'coming-soon' && <span aria-hidden="true">◷ </span>}
      {label}
    </span>
  );
}
